import type { RouteLocationNormalized, RouteRecordRaw } from "vue-router";
import type { Acl, User } from "vue-simple-acl/types/acl";
import { BREADCRUMBS } from "~/core/constants/breadcrumbs";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import { PATH_FLEETS, PATH_FLEETS_UID } from "~/modules/fleet/constants";

const routes: RouteRecordRaw[] = [
  {
    path: PATH_FLEETS,
    component: () => import("~/modules/fleet/views/FleetsPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) => can(ACLRoles.CAN_READ_DEVICE),
      breadcrumb: BREADCRUMBS.FLEETS,
    },
  },
  {
    path: PATH_FLEETS_UID,
    component: () => import("~/modules/fleet/views/FleetPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) => can(ACLRoles.CAN_READ_DEVICE),
      breadcrumb: BREADCRUMBS.FLEETS,
      backTo: PATH_FLEETS,
    },
  },
];

export default routes;
